// = Libs =
import { FC } from 'react';

// = Styles =
import classes from '../../form.module.scss';

// = Types =
import { FormErrorProps } from '../../form.types';

const FormError: FC<FormErrorProps> = (props) => {
  const { text = '' } = props;
  return <span className={classes.form__error}>{text}</span>;
};

export default FormError;
